import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  connect() {
    this.update()
    this.interval = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  update() {
    const target = new Date(this.targetValue)
    const now = new Date()
    const diff = target - now

    if (diff <= 0) {
      this.element.textContent = "Cerrado"
      this.element.classList.add("text-red-400")
      clearInterval(this.interval)
      return
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    if (days > 0) {
      this.element.textContent = `${days}d ${hours}h ${minutes}m`
    } else {
      this.element.textContent = `${hours}h ${minutes}m ${seconds}s`
    }
  }
}
